import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GlobalStyles } from '@mui/material';
import GlobalStyle from './styles/GlobalStyle';
import { SnackbarProvider } from 'notistack';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <SnackbarProvider
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        maxSnack={1}
        preventDuplicate
        autoHideDuration={5000}
        style={{ position: 'fixed', bottom: 16, left: 16 }}
    >
        <React.StrictMode>
            <GlobalStyles />
            <GlobalStyle />

            <App />

        </React.StrictMode>
    </SnackbarProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
